import React from 'react';
import starImage from '../images/star.svg';

export function Bullet(_: {}) {
    const star = <img alt="bullet" className="bullet" src={starImage}/>
    return <div className="bullet-container" style={{textAlign: 'center'}}><span>{star} {star} {star}</span></div>
}